import { Fragment, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { Layout as WebsiteLayout, useCalendarConfig } from '@wbk/calendar';
import FullpageAnimatedLogo from '../ui/Loading/FullpageAnimatedLogo';
import Seo from '../headers/seo';
import GlobalHead from '../headers/Index';

type Props = React.ComponentProps<typeof WebsiteLayout>;

const Layout = (props: Props) => {
  const { t } = useTranslation('common');
  const { config } = useCalendarConfig();

  return (
    <Fragment>
      <GlobalHead />

      {config && (
        <Seo
          title={config.seo.title || t('common:seo.title')}
          description={config.seo.description || t('common:seo.description')}
          keywords={config.seo.keywords || t('common:seo.keywords')}
          image={config.seo.image.url}
        />
      )}
      <WebsiteLayout {...props}>
        <Suspense fallback={<FullpageAnimatedLogo />}>
          <Outlet />
        </Suspense>
      </WebsiteLayout>
    </Fragment>
  );
};

export default Layout;
